import React from 'react';
import { StyledDashboard } from './Dashboard.style';

const Dashboard: React.FC = () => {
  return <StyledDashboard>It works!</StyledDashboard>;
};

export default Dashboard;
